import { login, logout, getInfo } from '@/api/login'
import { getToken, setToken, removeToken, encrypt } from '@/utils/auth'

const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    roles: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, userInfo.password).then(response => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },

    storeRoles({ commit }, roles) {
      sessionStorage.setItem('roles', encrypt(JSON.stringify(roles)))
    },

    setRole({ commit }, res) {
      commit('SET_TOKEN', '')
      commit('SET_NAME', '')
      removeToken()
      return new Promise((resolve, reject) => {
        const data = res
        const tokenStr = data.token
        setToken(tokenStr)
        sessionStorage.setItem("role_type", data.role_type)
        sessionStorage.setItem('role_id', data.role_id)
        commit('SET_TOKEN', tokenStr)
        resolve()
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo(sessionStorage.getItem('role_id')).then(response => {
          const data = response.data
          commit('SET_NAME', data.username)
          commit('SET_AVATAR', data.icon)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_NAME', '')
          removeToken()
          sessionStorage.clear()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js